var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import { cx } from 'emotion';
import BlockButton from './Utilities/BlockButton';
export default class Toggle extends PureComponent {
    render() {
        const _a = this.props, { on, onClick, onText, offText, size, disabled, className, style } = _a, rest = __rest(_a, ["on", "onClick", "onText", "offText", "size", "disabled", "className", "style"]);
        return (React.createElement(BlockButton, Object.assign({ className: cx('toggle', { [`toggle-${size}`]: size, 'toggle-on': on, 'toggle-off': !on, disabled, clickable: !disabled, className }), onClick: disabled ? null : onClick, style: style }, rest),
            React.createElement("div", { className: "toggle-label" }, on ? onText : offText),
            React.createElement("div", { className: "toggle-switch" })));
    }
}
Toggle.propTypes = {
    className: PropTypes.string,
    on: PropTypes.bool,
    onClick: PropTypes.func,
    onText: PropTypes.string,
    offText: PropTypes.string,
    size: PropTypes.oneOf(['sm']),
    style: StylePropType,
    disabled: PropTypes.bool,
};
Toggle.defaultProps = {
    className: '',
    onText: 'On',
    offText: 'Off',
    disabled: false,
    style: {},
};
